/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const featureProfileConfig = {
  url: 'https://kali-dev-dc.vlinder.io/digicert/org/get',
  image: 'https://i.ibb.co/KbKFHD9/indus-logo.png',
  orgId: '35d439a3-6c22-4495-b9cf-06a006ef1e3b',
  title: 'Indus International Schools',
  subtitle: '',
  editButtonDisabled: false,
  profileInfo: [
    {
      label: 'Email',
      value: 'feedback@indusschool.com',
    },
    {
      label: 'Phone Number',
      value: '+91 80 2289 5900',
    },
    {
      label: 'Address',
      value:
        'Billapura Cross, Sarjapura - Attibele Rd, Sarjapura, Bengaluru, Karnataka 562125',
    },
    {
      label: 'Webstie',
      value: 'https://www.indusschool.com/',
    },
  ],
};
